import React, { useState, useEffect } from "react";
import { producaov2 } from "../../../services/apis";
import AdminMenu from "../../../components/Admin/MenuDetalhes/AdminMenu";
import { Menu, Icon } from "semantic-ui-react";
import { Container, Title, SemanticTable } from "./styled";
import { isAuthAdmin } from "../../../services/auth";

function PessoaCursoPago() {
  const [pessoas, setPessoas] = useState([]);
  const [page, setPage] = useState(1);

  useEffect(() => {
    loadPessoasCursoPago();
    loadAuth();
  }, []);

  const loadAuth = async () => {
    const auth = await isAuthAdmin();

    if (!auth) {
      localStorage.setItem("redirect", `/admin/`);
      window.location.href = "/login";
      return null;
    }
  };

  const loadPessoasCursoPago = async (page = 1) => {
    const response = await producaov2.get(
      `/admin/pessoa/curso/pago?page=${page}`
    );
    let logs = {
      local: "PessoaCursoPago",
      texto: `listou as pessoas como curso pago`,
    };
    await producaov2.post("system_logs", { acao: JSON.stringify(logs) });
    const { data } = response;

    setPage(page);
    setPessoas(data);
  };

  const prevPage = () => {
    if (page === 1) return;

    const pageNumber = page - 1;

    loadPessoasCursoPago(pageNumber);
  };

  const nextPage = () => {
    if (pessoas === 1000) return;

    const pageNumber = page + 1;

    loadPessoasCursoPago(pageNumber);
  };

  return (
    <>
      <AdminMenu />

      <Container>
        <Title>Pessoas com o curso pago</Title>

        <SemanticTable size="big" celled>
          <SemanticTable.Header>
            <SemanticTable.Row>
              <SemanticTable.HeaderCell>Id_curso</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Curso</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>Pessoa</SemanticTable.HeaderCell>
              <SemanticTable.HeaderCell>E-mail</SemanticTable.HeaderCell>
            </SemanticTable.Row>
          </SemanticTable.Header>

          <SemanticTable.Body>
            {pessoas.map((pessoa) => (
              <SemanticTable.Row>
                <SemanticTable.Cell>{pessoa.id_curso}</SemanticTable.Cell>
                <SemanticTable.Cell>
                  {pessoa.curso !== null ? pessoa.curso.curso : null}
                </SemanticTable.Cell>
                <SemanticTable.Cell>
                  {pessoa.pessoa !== null ? pessoa.pessoa.nome : null}
                </SemanticTable.Cell>
                <SemanticTable.Cell>
                  {pessoa.pessoa !== null ? pessoa.pessoa.email : null}
                </SemanticTable.Cell>
              </SemanticTable.Row>
            ))}
          </SemanticTable.Body>

          <SemanticTable.Footer>
            <SemanticTable.Row>
              <SemanticTable.HeaderCell colSpan="4">
                <Menu floated="right" pagination>
                  <Menu.Item as="a" icon onClick={prevPage}>
                    <Icon name="chevron left" />
                  </Menu.Item>
                  <Menu.Item as="a" icon onClick={nextPage}>
                    <Icon name="chevron right" />
                  </Menu.Item>
                </Menu>
              </SemanticTable.HeaderCell>
            </SemanticTable.Row>
          </SemanticTable.Footer>
        </SemanticTable>
      </Container>
    </>
  );
}

export default PessoaCursoPago;
